import { createProviderWithoutThrowing } from "src/common/factories/createProvider.tsx";

export const {
  Provider: ControlLabelProvider,
  useContext: useControlLabelContext,
} = createProviderWithoutThrowing<{
  id?: string;
  disabled?: boolean;
} | null>(null, "ControlLabel");
